// extracted by mini-css-extract-plugin
export default {"wrapper":"account_wrapper__PQxI+","account":"account_account__djinC","card":"account_card__R9OLU"};